/**
 * Componente ServiceCard reutilizable
 * Tarjeta de servicio con icono, título y descripción
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ServiceCard = memo(({ 
  icon: Icon, 
  title, 
  description,
  className = ''
}) => (
  <article 
    className={`
      flex flex-col items-center justify-center p-6 
      bg-white rounded-2xl shadow-lg hover:shadow-xl 
      transition-all duration-300 group 
      w-full max-w-xs mx-auto border border-gray-100
      ${className}
    `}
    itemScope
    itemType="https://schema.org/Service"
  >
    <div className="mb-4 p-4 bg-blue-50 rounded-full group-hover:bg-blue-100 transition-colors duration-300 flex items-center justify-center group-hover:scale-110 transform">
      {Icon && (
        <Icon 
          className="text-blue-600 w-12 h-12 flex-shrink-0" 
          aria-hidden="true" 
        />
      )}
    </div>
    
    <h3 
      className="text-xl font-semibold text-gray-800 mb-2 text-center group-hover:text-blue-700 transition-colors"
      itemProp="name"
    >
      {title}
    </h3>
    
    <p 
      className="text-gray-600 text-center leading-relaxed"
      itemProp="description"
    >
      {description}
    </p>
  </article>
));

ServiceCard.displayName = 'ServiceCard';

ServiceCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ServiceCard;
